import { render, staticRenderFns } from "./FeedBackComponent.vue?vue&type=template&id=e488c460&"
import script from "./FeedBackComponent.vue?vue&type=script&lang=ts&"
export * from "./FeedBackComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports